module.exports = __webpack_public_path__ + "img/like_selected.e43d0f06.png";